import apiService from './apiService'

export const getPredictionCampaigns = (page) => {
  const params = {
    page: page ?? 1,
    item_per_page: 10
  }
  return apiService.get(URIS.prediction_campaign, {params})
}

export const postPredictionCampaign = (payload) => {
  return apiService.post(URIS.prediction_campaign, payload)
}

export const patchPredictionCampaign = (prediction_campaign_id, payload) => {
  return apiService.patch(URIS_D('prediction_campaign', prediction_campaign_id), payload)
}

export const deletePredictionCampaign = (prediction_campaign_id) => {
  return apiService.delete(URIS_D('prediction_campaign', prediction_campaign_id))
}

export const getPredictionCategoryInfo = (prediction_campaign_id) => {
  return apiService.get(URIS_D('categories', prediction_campaign_id))
}

export const getCandidates  = (id) => {
  return apiService.get(URIS_D("candidates",id))
}

export const postPredictionCategory = (prediction_campaign_id, payload) => {
  return apiService.post(URIS_D('categories', prediction_campaign_id), payload)
}

export const postCandidate = (id, payload) => {
  return apiService.post(URIS_D('candidates',id), payload)
}

export const patchCandidate = (candidate_id, payload) => {
  return apiService.patch(URIS_D('candidate_info', candidate_id), payload)
}

export const deleteCandidate = (candidate_id) => {
  return apiService.delete(URIS_D('candidate_info', candidate_id))
}

export const deletePredictionCategory= (id) => {
  return apiService.delete(URIS_D('update_categories',id))
}

export const patchPredictionCategories = (id, payload) => {
  return apiService.patch(URIS_D('update_categories',id), payload)
}

export const getPredictionCampaignInfo = (campaing_id) => {
  return apiService.get(URIS_D('prediction_campaign_info', campaing_id))
}

export const getPredictionResult = (campaign_id) => {
  return apiService.get(URIS_D('result',campaign_id))
}

export const getPredictionCampaign = (campaign_id) => {
  console.log('called')
  return apiService.get(URIS_D('prediction_campaign',campaign_id))
}


const URIS_D = (url, param1 = '', param2 = '') => {
  return {
    prediction_campaign: `/v1/cms/predictions/${param1}`,
    categories : `/v1/cms/predictions/${param1}/categories`,
    update_categories: `/v1/cms/prediction-categories/${param1}`,
    award_info: `/v1/cms/awards/${param1}`,
    candidates: `/v1/cms/prediction-categories/${param1}/candidates`,
    candidate_info: `/v1/cms/prediction-candidates/${param1}`,
    result: `/v1/cms/predictions/${param1}/result`,
    prediction_campaign_info: `/v1/prediction-campaigns/${param1}/info`,
  }[url]
}

const URIS = {
  prediction_campaign: '/v1/cms/predictions'
}



